import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../spinner'
import customInputLine from './field/customInputLine'
import { ButtonContained } from '../app-button/button'
import { required, email, minLength } from './validation/validation'

import { translate } from 'react-i18next'

const styles = theme => ({
  form: {
    maxWidth: 360,
    width: '100%',
  },

  invalid: {},

  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
  errorLogin: {
    color: '#ff4e44',
    textAlign: 'center',
    marginBottom: 20,
  },
  loginHelp: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 14,
  },
  linkNotAccount: {
    color: '#979197',
  },
  loginHelpLink: {
    color: '#8866ff',
  },
})

class LoginForm extends Component {
  resetValueField = name => {
    this.props.change(this.props.form, name, '')
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  getRegisterLink = () => {
    if (this.props.refJoin) {
      return '/join';
    }
    return '/register';
  }

  render() {
    const {
      classes,
      handleSubmit,
      errorLogin,
      isFetching,
      submitFailed,
      invalid,
      t,
    } = this.props

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        {errorLogin ? (
          <div className={classes.errorLogin}>{errorLogin}</div>
        ) : null}

        <div className={classes.inputWrapper}>
          <Field
            ref={ref => (this.field = ref)}
            name="email"
            component={customInputLine}
            type="text"
            label={t('login.email', { framework: 'react-i18next' })}
            validate={[required, email]}
            handleResetField={this.resetValueField}
            focus={true}
          />
        </div>
        <div className={classes.inputWrapper}>
          <Field
            name="password"
            component={customInputLine}
            type="password"
            label={t('login.password', { framework: 'react-i18next' })}
            validate={[required, minLength]}
            handleResetField={this.resetValueField}
          />
        </div>
        <ButtonContained
          style={{
            height: 64,
            fontSize: 16,
            width: '100%',
            padding: 0,
            marginBottom: '20px',
            fontWeight: 700,
          }}
          type="submit"
          color="primary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={
            isFetching ? (
              <Spinner stroke="#000000" />
            ) : (
              t('login.btnTitle', { framework: 'react-i18next' })
            )
          }
        />
        <div className={classes.loginHelp}>
          <a className={classes.loginHelpLink} href={`/password/reset`}>
            {t('login.forgotPassword', { framework: 'react-i18next' })}
          </a>
          <span className={classes.linkNotAccount}>
            {t('login.noAccount', { framework: 'react-i18next' })}{' '}
            <a href={this.getRegisterLink()} className={classes.loginHelpLink}>
              {t('login.signUp', { framework: 'react-i18next' })}
            </a>
          </span>
        </div>
      </form>
    )
  }
}

const mapDispatchToProps = {
  change,
}

LoginForm = reduxForm({
  form: 'login',
})(connect(null, mapDispatchToProps)(LoginForm))

export default withStyles(styles)(translate('common')(LoginForm))
